export const sendCheck = (input: any) => {
  const activeTex = 'Sent'
  const passiveText = 'Not Sent'

  let text = passiveText
  let boolen = true

  switch (input) {
    case '1':
      text = activeTex
      boolen = true
      break
    case '0':
      text = 'Passive'
      boolen = false
      break
    case 2:
      text = activeTex
      boolen = true
      break
    case 1:
      text = activeTex
      boolen = true
      break
    case 0:
      text = 'Passive'
      boolen = false
      break
  }

  return {boolen, text}
}

export const statusCheck = (input: any) => {
  const activeTex = 'Active'
  const passiveText = 'Passive'

  let text = passiveText
  let boolen = true

  switch (input) {
    case true:
      text = activeTex
      boolen = true
      break
    case false:
      text = passiveText
      boolen = false
      break
    case activeTex:
      text = activeTex
      boolen = true
      break
    case passiveText:
      text = 'Passive'
      boolen = false
      break
    case '1':
      text = activeTex
      boolen = true
      break
    case '2':
      text = activeTex
      boolen = true
      break
    case '0':
      text = 'Passive'
      boolen = false
      break
    case 2:
      text = activeTex
      boolen = true
      break
    case 1:
      text = activeTex
      boolen = true
      break
    case 0:
      text = 'Passive'
      boolen = false
      break
    case 'Loyalty Enabled':
      text = 'Loyalty Enabled'
      boolen = true
      break
    case 'Loyalty Disabled':
      text = 'Loyalty Disabled'
      boolen = false
      break
  }

  return {boolen, text}
}
